export default function SocialNodejs() {
  return (
    <div
      className="ion-icon-social-nodejs"
      dangerouslySetInnerHTML={{
        __html: `<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.2.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="512px" height="512px" viewBox="0 0 512 512" enable-background="new 0 0 512 512" xml:space="preserve">
<g transform="translate(96 96)">
	<g id="icon-nodejs_small">
		<path d="M159.917,384c-5.77,0-11.536-1.562-16.633-4.599l-52.985-32.44c-7.914-4.562-4.023-6.203-1.443-7.141
			c10.565-3.781,13.713-5.657,24.947-12.285c1.206-0.667,2.747-0.424,3.955,0.322l39.71,23.504c1.476,0.85,3.557,0.85,4.931,0
			l155.188-92.246c1.475-0.877,2.415-2.646,2.415-4.441V67.869c0-1.85-0.94-3.592-2.449-4.528L162.433-31.331
			c-1.478-0.894-3.421-0.894-4.898,0L2.516,63.374C0.972,64.277,0,66.072,0,67.869v186.805c0,1.813,0.972,3.513,2.481,4.389
			l39.929,23.972C66.02,295.239,80,282.865,80,268.424V84.725c0-2.652,2.047-4.727,4.596-4.727h22.809
			c2.515,0,4.597,2.072,4.597,4.727v183.698c0,32.563-19.353,51.248-49.199,51.248c-9.156,0-16.397,0-36.552-10.279l-41.584-24.781
			C-25.629,278.459-32,266.965-32,254.656V65.191c0-12.316,6.371-23.784,16.665-29.917L143.35-59.59
			c10.027-5.88,23.374-5.88,33.332,0l158.65,94.864C345.63,41.423,352,52.899,352,65.191v189.465c0,12.309-6.37,23.75-16.668,29.953
			l-158.65,94.774c-5.097,3.036-10.832,4.599-16.698,4.599L159.917,384z"/>
		<path d="M208.943,255.998c-64.61,0-84.006-31.61-84.006-59.271c0-2.629,2.048-4.729,4.562-4.729h20.521
			c2.282,0,4.227,1.7,4.562,4.016c3.084,21.602,16.748,31.15,54.324,31.15c33.399,0,47.091-10.346,47.091-28.684
			c0-10.592-3.463-18.424-55.407-23.697c-43.427-4.441-70.288-14.373-70.288-50.295c0-33.135,26.996-52.49,72.234-52.49
			c46.128,0,76.462,14,79.173,50.829c0.102,1.337-0.368,2.629-1.241,3.644c-0.871,0.965-2.078,1.527-3.353,1.527h-20.591
			c-2.146,0-4.024-1.562-4.459-3.713c-4.401-16.953-16.97-23.402-49.563-23.402c-36.486,0-40.746,12.753-40.746,22.607
			c0,11.963,5.031,15.441,54.294,22.172c48.761,6.663,71.933,16.117,71.933,51.552c0,35.781-28.808,58.783-79.075,58.783
			L208.943,255.998L208.943,255.998z"/>
	</g>
</g>
</svg>
`,
      }}
    />
  )
}
